import { ContactUsFormData } from '../types/ContactUsFormData';
import { ContactUsPayload } from '../types/ContactUsPayload';

export function formDataToPayload(data: ContactUsFormData): ContactUsPayload {
    if (data.purpose === undefined) throw new Error('Need to fill purpose');

    return {
        referrer: document.referrer,
        full_url: window.location.href,
        user_agent: navigator.userAgent,
        name: data.name,
        email: data.email,
        message: data.message,
        purpose: data.purpose,
        attachments: data.attachments ?? null,
    };
}

export function payloadToFormDataObject(payload: ContactUsPayload): FormData {
    const formData = new FormData();
    Object.keys(payload).map((key) => {
        const value = payload[key as keyof ContactUsPayload];
        if (key === 'attachments' && value !== null)
            (value as File[]).forEach((attachment) => {
                formData.append('attachments[]', attachment);
            });
        else formData.append(key, value as string);
    });
    return formData;
}
